/**
 * Google Maps API Loader
 * Dynamically loads Google Maps script with Places library
 */

let isLoading = false;
let isLoaded = false;

export const loadGoogleMaps = async (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // Already loaded
    if (isLoaded) {
      resolve();
      return;
    }

    // Already loading, wait for it
    if (isLoading) {
      const checkLoaded = setInterval(() => {
        if ((window as any).google?.maps?.places) {
          clearInterval(checkLoaded);
          resolve();
        }
      }, 100);
      return;
    }

    isLoading = true;

    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

    if (!apiKey || apiKey === 'YOUR_GOOGLE_MAPS_API_KEY') {
      reject(
        new Error(
          'Google Maps API key is missing. Set REACT_APP_GOOGLE_MAPS_API_KEY in frontend/.env'
        )
      );
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&language=en`;

    script.onload = () => {
      isLoaded = true;
      resolve();
    };

    script.onerror = () => {
      reject(new Error('Failed to load Google Maps API'));
    };

    document.head.appendChild(script);
  });
};

export const isGoogleMapsLoaded = (): boolean => {
  return (window as any).google?.maps?.places !== undefined;
};
